export default "__VITE_ASSET__n1Zsvfi___"